import type { ConversationThreadId } from "@redotech/effect-api-shared/ids/definitions";
import type {
  Message,
  MessageChannel,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import { memo } from "react";
import { ChatMessageBubble } from "./chat-message-bubble";
import { MetaCommentActions } from "./meta-comment-actions";

interface MetaCommentChatMessageBubbleProps {
  message: Message;
  channel: MessageChannel;
  threadId: ConversationThreadId;
}

export const MetaCommentChatMessageBubble = memo(
  function MetaCommentChatMessageBubble({
    message,
    channel,
    threadId,
  }: MetaCommentChatMessageBubbleProps) {
    const channelData =
      message.channelData &&
      (message.channelData._tag === "facebookComment" ||
        message.channelData._tag === "instagramComment")
        ? message.channelData
        : null;

    const isHidden = channelData?.state === "hidden";
    const isLiked = (channelData?.attributes ?? []).includes("liked");

    return (
      <ChatMessageBubble
        actions={
          <MetaCommentActions
            channel={channel}
            commentId={message.externalMessageId}
            isHidden={isHidden}
            isLiked={isLiked}
            messageId={message.id}
            threadId={threadId}
          />
        }
        message={message}
      />
    );
  },
);
